export const formatDate = (timestamp, language) => {
    const date = new Date(timestamp);
    const month = date.getMonth()+1 < 10 ? `0${date.getMonth()+1}` : date.getMonth()+1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    const lang = language?language:window?.localStorage?.getItem('language')
    if (lang==='fr') return `${day}/${month}/${date.getFullYear()} ${hours}:${minutes}`;
    else return `${date.getFullYear()}/${month}/${day} ${hours}:${minutes}`;
  };